import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardListModule } from '../card-list';
import { LastElementsOpenedComponent } from './last-elements-opened.component';

@NgModule({
    declarations: [LastElementsOpenedComponent],
    imports: [CommonModule, CardListModule],
    exports: [LastElementsOpenedComponent],
})
export class LastElementsOpenedModule {}
